import { render, staticRenderFns } from "./IntRatePlans.vue?vue&type=template&id=eb081b06&"
import script from "./IntRatePlans.vue?vue&type=script&lang=js&"
export * from "./IntRatePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports